module.exports = __webpack_public_path__ + "static/flags/WZ-91f7657f3be6fa54b9eaf71b8b277cf6.gif";